import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { Globals } from '../../../../app.globals';

/**
 * Typeahead / suggest search input component.
 * See https://valor-software.com/ngx-bootstrap/#/typeahead
 *
 * Accepts input `values` type of `Observable<string[]>` to offer string values.
 * Emits `inputChanged` events with a search text typed by a user.
 *
 * This is presentational component only and data fetching based on user input must handle parent component.
 *
 * Warning: Currently there is an issue with ngx-bootstrap: https://github.com/valor-software/ngx-bootstrap/issues/1281.
 * tl;dr: First suggested option is always pre-picked. This component uses workaround to solve this issue.
 */
@Component({
    selector: 'ssf-typeahead-input',
    template: require('./typeahead-input.component.html'),
    styles: [require('./typeahead-input.component.scss')]
})
export class TypeaheadInputComponent implements OnInit {

    /**
     * To be available in HTML template.
     */
    public optionsLimit = Globals.typeahead.optionsLimit;
    /**
     * Maximum number of options shown at any time in the box. The rest is accessible via scrollbar.
     */
    public scrollableViewSize = Globals.typeahead.scrollableViewSize;
    /**
     * options to pick from
     */
    @Input() values$: Observable<string[]>;
    /**
     * if the first suggested option should be highlighted.. when false, user can confirm written text with key Enter
     */
    @Input() prepickFirst = false;
    /**
     * currently picked/written text
     */
    @Input() inputValue: string;
    /**
     * if the values offered are objects, this attribute specifies name of the object's property, which contains
     * text to be displayed
     */
    @Input() fieldName: string;
    /**
     * used for detection whether written text matches any of the suggested elements
     */
    @Input() inactive = false;
    /**
     * adds HTML's disabled attribute to typeahead
     */
    @Input() disabled = false;
    /**
     * translation string identifying path to translation file
     */
    @Input() disabledTitleI18n: string;
    /**
     * determines if there is a clear button
     */
    @Input() enableClearing = false;
    /**
     * emits, when any letter is typed or erased
     */
    @Output() onInputChanged = new EventEmitter<string>();
    /**
     * emits, when user uses an offered option by clicking on it
     */
    @Output() onInputSelect = new EventEmitter<TypeaheadMatch>();
    /**
     * emits, when user clicks clear button
     */
    @Output() onClear = new EventEmitter<any>();
    public i18n = 'SHARED.TYPEAHEAD.';

    onInput(inputValue) {
        this.onInputChanged.emit(inputValue);
    }

    onSelect(selectedValue) {
        this.onInputSelect.emit(selectedValue);
    }

    ngOnInit() {
        if (!this.prepickFirst) {
            this.values$ = this.values$.map((obj) => {
                // ngx-bootstrap issue workaround (for more info check component doc)
                let res = [];
                res.push(this.inputValue);
                return res.concat(obj);
            });
        }
    }

    clear() {
        this.inputValue = '';
        this.onClear.emit(null);
        this.onInputChanged.emit(this.inputValue);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/typeahead-input/typeahead-input.component.ts